var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusDt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4455 0.273005C16.5 0.379961 16.5 0.519974 16.5 0.8V2H18C19.11 2 19.99 2.89 19.99 4L20 14C20 15.11 19.11 16 18 16H2C0.889999 16 0 15.11 0 14V4C0 2.89 0.889999 2 2 2H3.5V0.8C3.5 0.519974 3.5 0.379961 3.5545 0.273005C3.60243 0.178924 3.67892 0.102433 3.773 0.0544967C3.87996 0 4.01997 0 4.3 0H6.7C6.98003 0 7.12004 0 7.227 0.0544967C7.32108 0.102433 7.39757 0.178924 7.4455 0.273005C7.5 0.379961 7.5 0.519974 7.5 0.8V2H12.5V0.8C12.5 0.519974 12.5 0.379961 12.5545 0.273005C12.6024 0.178924 12.6789 0.102433 12.773 0.0544967C12.88 0 13.02 0 13.3 0H15.7C15.98 0 16.12 0 16.227 0.0544967C16.3211 0.102433 16.3976 0.178924 16.4455 0.273005ZM17.25 8H16V12H8V10.5H14.5V8H13.25L15.25 5.5L17.25 8ZM12 6H4V10H2.75L4.75 12.5L6.75 10H5.5V7.5H12V6Z",
    fill: "#0088F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDt);
export default __webpack_public_path__ + "static/media/status_dt.14b2798066ee70f3cbb35fc6c308918c.svg";
export { ForwardRef as ReactComponent };